import React, { Fragment } from 'react';
import jsCookie from 'js-cookie';
import { COOKIES } from '../constants';
import createRequest from '../utils/requestService';

const getAffiliate = () => {
  const cjDetailsCookie = jsCookie.get(COOKIES.CJ_DETAILS);

  if (cjDetailsCookie) {
    const json = JSON.parse(cjDetailsCookie);
    if (json.cj_sourced) {
      return 'cj';
    }
  }
  return null;
};

const createFreeUser = (userValues, activePackage) => {
  let url = '/v3/public/s2s/signup';

  const body = {
    ...userValues,
    // I believe this is created before user gets to signup app
    signup_bi: jsCookie.get(COOKIES.SF_DETAILS),
    // I believe this is created before user gets to signup app
    sendgrid_partner: jsCookie.get(COOKIES.SENDGRID_PARTNER),
    package_uuid: activePackage.id,
    signup_session_token: jsCookie.get(COOKIES.SIGNUP_SESSION),
    // is_cutoff_trial: 1, // isCutoffTrial set in https://github.com/sendgrid/mako/blob/dfe9d40807065cd893499c0ff6bc331174afe35f/src/router.js
  };

  // aws flow!
  if (activePackage.is_aws) {
    if (activePackage.cuuid) {
      url = '/v3/public/s2s/signup/partner';
      body.cuuid = activePackage.cuuid;
    } else {
      return Promise.resolve({
        errorText: <Fragment>We couldnt find your AWS account. Please visit the <a href="https://aws.amazon.com/marketplace/pp/B074CQY6KB">AWS Marketplace</a> and try to sign up again.</Fragment>,
      });
    }
  }

  const affiliate = getAffiliate();
  if (affiliate) {
    body.affiliate = affiliate;
  }

  return fetch(createRequest(url, { body })).then(response => response.json());
};

export default createFreeUser;



// WEBPACK FOOTER //
// ./src/utils/userCreation.js